import classnames from "classnames";
import Cleave from "cleave.js/react";
import React, { useCallback, useMemo } from "react";
import { FormText } from "reactstrap";
import { InputWrapper } from "./InputWrapper";
import { parseCurrencyToCents } from "../../../util/formatters";

export const MoneyInput = ({ children, input, label, meta, ...rest }) => {
  return (
    <InputWrapper label={label} required={rest.required}>
      <Cleave
        options={{
          prefix: "$",
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          rawValueTrimPrefix: true,
          numeralDecimalScale: 2,
        }}
        {...input}
        className={classnames("form-control", rest.className, {
          "is-invalid": Boolean(meta.touched && meta.error),
        })}
        {...rest}
      />
      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}
      {children}
    </InputWrapper>
  );
};

export const CentsInput = ({ input, ...rest }) => {
  const handleChange = useCallback(
    (e) => {
      input.onChange(_.isNil(e.target.value) ? e.target.value : parseCurrencyToCents(e.target.value));
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input.onChange]
  );

  const inputValue = useMemo(() => (input.value ? input.value / 100 : undefined), [input.value]);

  return <MoneyInput {...input} onChange={handleChange} value={inputValue} {...rest} />;
};
